import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Coffee, MapPin, Phone } from 'lucide-react';

const Layout = ({ children }) => {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <nav className="sticky top-0 z-50 bg-card/95 backdrop-blur-sm border-b border-border shadow-sm">
        <div className="px-6 md:px-12 lg:px-24 py-5">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
              <Coffee className="h-7 w-7 text-accent" strokeWidth={1.75} />
              <div className="flex flex-col">
                <span className="text-2xl font-semibold tracking-tight">Brew & Bloom</span>
                <span className="text-xs text-muted-foreground tracking-wider uppercase">Coffee Directory</span>
              </div>
            </Link>
            <div className="flex items-center gap-8">
              <Link
                to="/"
                data-testid="nav-home-link"
                className={`text-sm font-medium tracking-wide uppercase transition-colors relative ${
                  location.pathname === '/' ? 'text-accent' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                Home
                {location.pathname === '/' && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent"></span>
                )}
              </Link>
              <Link
                to="/directory"
                data-testid="nav-directory-link"
                className={`text-sm font-medium tracking-wide uppercase transition-colors flex items-center gap-2 relative ${
                  location.pathname === '/directory' ? 'text-accent' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                <MapPin className="h-4 w-4" strokeWidth={2} />
                Directory
                {location.pathname === '/directory' && (
                  <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-accent"></span>
                )}
              </Link>
              <Link
                to="/signup"
                data-testid="nav-signup-link"
                className="px-4 py-2 bg-secondary text-secondary-foreground rounded font-medium text-sm hover:bg-secondary/80 transition-all"
              >
                + Add Your Cafe
              </Link>
              <a
                href="tel:+639603059060"
                data-testid="contact-button"
                className="contact-flash-button flex items-center gap-2 px-5 py-2.5 bg-accent text-accent-foreground rounded font-medium text-sm hover:bg-accent/90 transition-all hover:scale-105 shadow-md"
              >
                <Phone className="h-4 w-4" strokeWidth={2} />
                <span>+63 960 305 9060</span>
              </a>
            </div>
          </div>
        </div>
      </nav>

      <main className="flex-1">{children}</main>

      <footer className="bg-primary text-primary-foreground mt-32 border-t border-border/20">
        <div className="px-6 md:px-12 lg:px-24 py-16">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <Coffee className="h-6 w-6" strokeWidth={1.75} />
                <span className="text-xl font-semibold">Brew & Bloom</span>
              </div>
              <p className="text-sm text-primary-foreground/70 leading-relaxed">
                Connecting coffee lovers with the finest artisan cafes in Angeles City, Pampanga.
              </p>
            </div>
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Quick Links</h3>
              <div className="space-y-2">
                <Link to="/" className="block text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Home
                </Link>
                <Link to="/directory" className="block text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Directory
                </Link>
              </div>
            </div>
            <div>
              <h3 className="text-sm font-semibold uppercase tracking-wider mb-4">Contact</h3>
              <a href="tel:+639603059060" className="block text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                +63 960 305 9060
              </a>
            </div>
          </div>
          <div className="pt-8 border-t border-primary-foreground/10 text-center">
            <p className="text-sm text-primary-foreground/60">
              © 2025 Brew & Bloom. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;